import { render, staticRenderFns } from "./setAccountEdit.vue?vue&type=template&id=565e20da&scoped=true&"
import script from "./setAccountEdit.vue?vue&type=script&lang=js&"
export * from "./setAccountEdit.vue?vue&type=script&lang=js&"
import style0 from "./setAccountEdit.vue?vue&type=style&index=0&id=565e20da&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "565e20da",
  null
  
)

export default component.exports